import client from '../../client';

const SALES_USERS = {
  getSalesUsers(saleId) {
    return client.get(`/sellers/${client.customerId()}/sales/${saleId}/sales_users`);
  },

  createSalesUser(saleId, params) {
    return client.post(`/sellers/${client.customerId()}/sales/${saleId}/sales_users`, { sales_user: params });
  },

  updateSalesUser(saleId, salesUserId, params) {
    return client.put(`/sellers/${client.customerId()}/sales/${saleId}/sales_users/${salesUserId}`,  { sales_user: params });
  },

  removeSalesUser(saleId, salesUserId) {
    return client.delete(`/sellers/${client.customerId()}/sales/${saleId}/sales_users/${salesUserId}`);
  },
};

export default SALES_USERS;
